export const Colors = {
  red: {
    r: 244,
    g: 67,
    b: 54
  },
  pink: {
    r: 233,
    g: 30,
    b: 99
  },
  purple: {
    r: 156,
    g: 39,
    b: 176
  },
  deepPurple: {
    r: 103,
    g: 58,
    b: 183
  },
  indigo: {
    r: 63,
    g: 81,
    b: 181
  },
  blue: {
    r: 33,
    g: 150,
    b: 243
  },
  lightBlue: {
    r: 3,
    g: 169,
    b: 244
  },
  cyan: {
    r: 0,
    g: 188,
    b: 212
  },
  teal: {
    r: 0,
    g: 150,
    b: 136
  },
  green: {
    r: 76,
    g: 175,
    b: 80
  },
  lightGreen: {
    r: 139,
    g: 195,
    b: 74
  },
  lime: {
    r: 205,
    g: 220,
    b: 57
  },
  modifiedYellow: {
    r: 255,
    g: 206,
    b: 86
  },
  yellow: {
    r: 255,
    g: 235,
    b: 59
  },
  amber: {
    r: 255,
    g: 193,
    b: 7
  },
  orange: {
    r: 255,
    g: 152,
    b: 0
  },
  deepOrange: {
    r: 255,
    g: 87,
    b: 34
  },
  brown: {
    r: 121,
    g: 85,
    b: 72
  },
  grey: {
    r: 158,
    g: 158,
    b: 158
  },
  blueGrey: {
    r: 96,
    g: 125,
    b: 139
  }
}

  export function getColorAsString(name, alpha = 1) {
    let c = Colors[name]
    return `rgba(${c.r}, ${c.g}, ${c.b}, ${alpha})`
  }

  export function getColorsAsString(alpha = 1) {
    let array = []
    Object.keys(Colors).forEach(function(key,index) {
      array.push(getColorAsString(key, alpha))
    });

    return array
  }

  export function arrayOfColorsAsString(colors = [], alpha = 1) {
    return colors.map(color => {
      return getColorAsString(color, alpha)
    })
  }

  export default Colors
